(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name ResultadosController
* @description
* This is main controller
**/ 

    angular
    .module('appback')
    .controller('ResultadosController', ResultadosController);

    ResultadosController.$inject = ["socket","PreanaliticaService","FotopublicacionService","GenerallabService","$scope","ResultadosService","$timeout","$uibModal","$location",'$anchorScroll','$window'];

    function ResultadosController(socket,PreanaliticaService,FotopublicacionService,GenerallabService,$scope,ResultadosService,$timeout,$uibModal,$location,$anchorScroll,$window)
    {
      var vm = this;
      //console.log(socket);
      vm.socket = socket;
      /*vm.socket.on('init', function (data) {
        ////console.log("init",data);
      });*/
      vm.socket.on("events:reset",function(){
        vm.resetEvents();
      })
      vm.socket.on('user:listado', function (data) {
        //console.log("data",data);
        vm.infoSock.users = data.users;
        vm.infoSock.usersNames = [];
        for(var cont=0;cont<data.users.length;cont++){
          var username = data.users[cont].name;
          var cookie = "";
          if(typeof(data.users[cont].cookie.validador)!='undefined' && data.users[cont].cookie!=''){
            cookie = "("+data.users[cont].cookie.validador.nombre + " " + data.users[cont].cookie.validador.apellidos+")";
          }
          vm.infoSock.usersNames.push(username+ " "+cookie);
        }
        ////console.log("usernames", vm.infoSock.usersNames);
        ////console.log(Object.keys(vm.infoSock.users).length);
        ////console.log("listado",data);
      });

      vm.socket.on('peticion:guardar', function (data) {
        ////console.log("peticion:guardar",data);
        ////console.log("vm.id",vm.id);
        var res = false;
        if(vm.resultados){
          for(var cont=0;cont<vm.resultados.length;cont++){
            ////console.log("resultado",vm.resultados[cont]);
            if(vm.resultados[cont].id==data.id){
              if(data.datapet.code==1){
                  vm.resultados[cont].fecha_validacion = data.datapet.fecha_validacion;
                  /*if(data.datapet.fecha_validacion){

                  }*/
              }
              if(Object.keys(data.infopet).length>0){
                vm.resultados = data.infopet.resultados;
              }
              vm.getAcciones();
            }
          }
        }
        
        /*vm.loadingFull = false;
        if(data.code==1){
          peticion.fecha_validacion = data.fecha_validacion;
        }
        vm.getAcciones();*/
      });
      /*vm.socket.on('change:comment', function (data) {
        vm.resultados[cont].comentarios_json = data.data.comentarios_json;
      });*/
      vm.socket.on('change:results', function (data) {
        return false;//DE MOMENTO NO HACEMOS NADA
        //console.log("dataResults",data.data);
          for(var cont=0;cont<vm.resultados.length;cont++){
            //console.log("res",vm.resultados[cont]);
            for(var cont2=0;cont2<vm.resultados[cont].analiticas.length;cont2++){
              for(var cont3=0;cont3<data.data.length;cont3++){
                data.data[cont3].resultado.ignoreSocket = false;
                //vm.resultados[cont].analiticas[cont2].ignoreSendSocket = false;
                if(data.data[cont3].analitica_id==vm.resultados[cont].analiticas[cont2].analitica_id && data.data[cont3].peticion_id == vm.resultados[cont].id){
                  //console.log("ENTRO");
                  data.data[cont3].resultado.ignoreSocket = true;
                  vm.resultados[cont].analiticas[cont2].resultado = data.data[cont3].resultado;
                  //vm.resultados[cont].analiticas[cont2].ignoreSendSocket = true;
                  //vm.resultados[cont].analiticas[cont2].resultado.validado = data.data[cont3].resultado.validado;
                }
              }
            }
          }
        
        ////console.log("dataresult",data);
      });
      
    	//////console.log("ResultadosController Enabled");
    	vm.id = "";
    	vm.resultados = {};
      vm.loadComments = false;
      vm.generalLab = GenerallabService;
      vm.acciones = [];
      vm.tablanotasvalores = [];

      vm.theText = "";

      var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if(SpeechRecognition){
        vm.recognition = new SpeechRecognition();
      }else{
        vm.recognition = {};
      }

      /*vm.readOutLoud = function(message) {
        var speech = new SpeechSynthesisUtterance();

        // Set the text and voice attributes.
        speech.text = message;
        speech.volume = 1;
        speech.rate = 1;
        speech.pitch = 1;

        window.speechSynthesis.speak(speech);
      }*/


      //vm.context = new webkitAudioContext();
      
      vm.recognition.continuous = true;
      vm.recognition.interimResults = true;

      vm.recognition.onend = function (event) {
        //console.log("ONEND",event);
        if(vm.audioRes){
          //modelText+=" ";
          vm.recognition.start();
        }
      };
      vm.recognition.onerror = function (event) {
        //console.log("ONERROR",event);
        
      };

      vm.recognition.onaudiostart = function() {
        //console.log('Audio capturing started');
      }
      vm.recognition.onaudioend = function(event) {
        //console.log('Audio capturing stop',event);
      }

      vm.audioRes = false;

      vm.data = new FormData();
      vm.rec = false;

     

       vm.audioPlay = false;

      vm.playAudio = function(file){
        if(vm.audioPlay){
          vm.audioPlay.pause();
        }
        vm.audioPlay = new Audio('/backend/uploads/audios/'+file.fileName);


        vm.audioPlay.play();
      }
      vm.stopAudio = function(file){
        vm.audioPlay.pause();
        vm.audioPlay = false;
      }

      

      

      vm.uploadToServer = function(blob, callback) {
                  var url = URL.createObjectURL(blob);
                  //console.log(url);
          //var blob = record.blob;

          //console.log("blob",blob);
          var fileType = blob.type.split('/')[0] || 'audio';
          var fileName = (Math.random() * 1000).toString().replace('.', '');

          if (fileType === 'audio') {
              fileName += '.' + (!!navigator.mozGetUserMedia ? 'mp3' : 'mp3');
          } else {
              fileName += '.webm';
          }

          // create FormData
          var formData = new FormData();
          formData.append(fileType + '-filename', fileName);
          formData.append(fileType + '-blob', blob);

          //callback('Uploading ' + fileType + ' recording to server.');

          // var upload_url = 'https://your-domain.com/files-uploader/';
          var upload_url = '/backend/resultadopeticion/saveaudio';

          // var upload_directory = upload_url;
          var upload_directory = 'uploads/';

          vm.makeXMLHttpRequest(upload_url, formData, function(progress) {
              if (progress !== 'upload-ended') {
                  //callback(progress);
                  return;
              }

              callback('ended', fileName);

              // to make sure we can delete as soon as visitor leaves
              //listOfFilesUploaded.push(upload_directory + fileName);
          });
      }

      vm.makeXMLHttpRequest = function(url, data, callback) {
          var request = new XMLHttpRequest();
          request.onreadystatechange = function() {
              if (request.readyState == 4 && request.status == 200) {
                  callback('upload-ended');
              }
          };

          request.upload.onloadstart = function() {
              callback('Upload started...');
          };

          request.upload.onprogress = function(event) {
              callback('Upload Progress ' + Math.round(event.loaded / event.total * 100) + "%");
          };

          request.upload.onload = function() {
              callback('progress-about-to-end');
          };

          request.upload.onload = function() {
              callback('progress-ended');
          };

          request.upload.onerror = function(error) {
              callback('Failed to upload to server');
              console.error('XMLHttpRequest failed', error);
          };

          request.upload.onabort = function(error) {
              callback('Upload aborted.');
              console.error('XMLHttpRequest aborted', error);
          };

          request.open('POST', url);
          request.send(data);
      }


      vm.rtcSession = {
          
          audio: true,
      };
      vm.recordRTC;


       vm.recorder;

       vm.buscarFrases = function(frase){
         for(var cont=0;cont<vm.tablanotasvalores.length;cont++){
           var splitBusqueda = vm.tablanotasvalores[cont].palabras.split(",");
           for(var cont2=0;cont2<splitBusqueda.length;cont2++){
              //var indexOfFrase = frase.toLowerCase().indexOf(splitBusqueda[cont2].toLowerCase().trim());
              var splitF = frase.split(splitBusqueda[cont2].toLowerCase().trim());
              frase = splitF.join(vm.tablanotasvalores[cont].reemplazo);
           }

         }
         /*var reemplazar = {
           'abrir paréntesis':'(',
           'cerrar paréntesis':')',
           'dos puntos':':'
         };
         Object.keys(reemplazar).forEach(key => {
           var splitF = frase.split(key);
           frase = splitF.join(reemplazar[key]);
         });

          var numeros = ["uno","dos","tres","cuatro","cinco","seis"];
          for(var cont=0;cont<numeros.length;cont++){
            var frasebuscar = ['makro'+(cont+1),'makro '+(cont+1),'macro '+(cont+1),'macro '+numeros[cont],'macro'+numeros[cont],'macro-'+numeros[cont],'macro-'+(cont+1)];
            for(var cont2=0;cont2<frasebuscar.length;cont2++){

              //console.log('macro '+numeros[cont]);
              var indexOfFrase = frase.toLowerCase().indexOf(frasebuscar[cont2]);
              if(indexOfFrase!==-1){
                //console.log("ENTRO EN MACRO 1");
                var final = frase.slice(indexOfFrase+(frasebuscar[cont2].length+1),frase.length) ;

                $('.macro_'+(cont+1)).val(final)
              }else{
                //console.log("NO ENTRO EN MACRO 1");
              }
            }
          }*/
          return frase;
       }
       vm.preText = "";
      vm.dictateIt = function(modelText){
        //console.log("START DICT");
        //console.log("start recg",vm.recognition);
        var languagesTrans = {'1':'es-ES','2':'ca-ES','3':'pt-PT','4':'en-EN'};
        vm.recognition.lang = languagesTrans[vm.lang_trans];

        vm.recognition.start();
        vm.recognition.onresult = function (event) {
          var frase = "";
          console.log("evRR",event.results);
          //console.log("modelText",modelText);
            if(frase!=""){
               frase+=" ";

            }
                  vm.preText = "";

            for (var i = event.resultIndex; i < event.results.length; i++) {

              for (var ind = 0; ind < event.results[i].length; ind++) {
                if (event.results[i].isFinal) {
                  //frase  += event.results[i][0].transcript;
                  frase+=event.results[i][ind].transcript;
                }else{
                  vm.preText += event.results[i][ind].transcript;
                }
              }
            }
            frase = vm.buscarFrases(frase);
            $timeout(function(){
              modelText.notas = modelText.notas+frase;
            })
        };
        //console.log("ENTRO");
             navigator.getUserMedia(vm.rtcSession, (mediaStream) => {
                // RecordRTC requires "second" parameter named as "options" or "configuration" or "hints"
                /*vm.recordRTC = RecordRTC(mediaStream, vm.rtcSession);
                vm.recordRTC.startRecording();*/
                var audio_context = new AudioContext;
                var inputPoint = audio_context.createMediaStreamSource(mediaStream);
                vm.recorder = new Recorder(inputPoint,{numChannels:1});
                vm.recorder.record();

            }, () => {
                console.error('An error has occurred while attempting to get user media.');
            });
            
        
        vm.audioRes = true;
      }
      vm.stopDict = function(modelText){
        //console.log("STOP DICT");
        vm.audioRes = false;
        vm.recognition.stop();

        vm.recorder.stop();
        vm.recorder.exportWAV(function(blob){
          //console.log("STOP REC");
          vm.uploadToServer(blob,function(code,fileName){
            //callback
            $timeout(function(){
                //console.log("filename",fileName);
              if(typeof(modelText.files)=='undefined'){
                modelText.files = [];
              }
              modelText.files.push({analitica:'',fileName:fileName})
            })
            
          })
        });
        /*vm.recordRTC.stopRecording(function(url) {
          vm.uploadToServer(this.blob,function(code,fileName){
            //callback
            $timeout(function(){
                //console.log("filename",fileName);
              if(typeof(modelText.files)=='undefined'){
                modelText.files = [];
              }
              modelText.files.push({analitica:'',fileName:fileName})
            })
            
          })
        });*/

         ////console.log("record",vm.recordRTC);
        
        
       
      }


      vm.sumaValores = function(item){
        //console.log("res",item.resultado.resultado);
        //console.log("sum",item.analitica.sumaresta);
        return (Number(item.resultado.resultado) + Number(item.analitica.sumaresta)).toFixed(2)
      }
      //vm.codeVisita = 0;
    	vm.categorias = [];

      vm.infoSock = {}
      vm.resultadosMaquina = [];

    	vm.animal = {};
        vm.cookie = false;
        vm.timer = "";
        vm.loading = false;
        vm.peticion = {};
        function format(icon) {
            var originalOption = icon.element;
              var str = "";
              if(typeof $(originalOption).data('icon') != 'undefined'){
                str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
                return $(str+" ");
              }else{
                return icon.text || icon.value;
              }
        }

        vm.optionsTecnica = {
          ajax: {
                url: "/backend/resultadopeticion/tecnicasanalitica",
                dataType: 'json',
                delay: 250,
                data: function (params,extra) {
                  return {
                    q: params.term, // search term
                    page: params.page,
                    field: 'nombre',
                    per_page: 20,
                    nodetype:'tecnica',
                    //extra:scope.extraparams
                  };
                },
                processResults: function (data, params) {
                  params.page = params.page || 1;
                  return {
                    results: data.items,
                    pagination: {
                      more: (params.page * 1) < data.total_count
                    }
                  };
                },
                cache: true
            },
            templateSelection: format,
            templateResult: format
        }

        $scope.$on('guardarCambios', function (event, data) {
          var peticionCurrent = false;
          for(var cont=0;cont<vm.resultados.length;cont++){
            if(vm.resultados[cont].id==vm.id){
              peticionCurrent = vm.resultados[cont];
            }
          }//BUSCAMOS LA PETICION QUE ES ACTUALMENTE y guardamos
          vm.guardarResultados(peticionCurrent,'',false,data.callback);
        });

        vm.renovarCookie = function(cookie){
            if(vm.timer){
                clearInterval(vm.timer);
            }
            if(cookie.cookie.caduca){
                vm.cookie = cookie;
                vm.timer = setInterval(function() {
                    var compareDate = new Date(cookie.cookie.caduca);
                    vm.timeBetweenDates(compareDate);
                }, 1000);
            }
        }

        vm.cambiarestadoMues = function(tV){
          //console.log(tV);
          ResultadosService.cambiarEstadoMuestra(tV,function(result){
          });
        }

        vm.deslogear = function(){
          ResultadosService.deslogear(function(data){
            clearInterval(vm.timer);
            vm.cookie = false;
          });
        }

        
        vm.loadingComments = false;
        vm.popupComentarios = "";
        vm.comentarios = function(peticion,cat){
           vm.popupComentarios = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  //backdrop  : 'static',
                  templateUrl: '/backend/resultadopeticion/templateresultados?name=comentarios.twig',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.categoria = cat;
                    $scope.peticion = peticion;
                    $scope.filtros = {
                      buscador:'',
                      remove_tags : false,
                      page:0
                    }
                    $scope.filtros.categoria;

                    // Función quie inicializa los comentarios para llamarla con ng-change
                    $scope.init = function(page){
                      // Si está definida es que se está paginando
                      if (angular.isDefined(page)) {
                        $scope.filtros.page = page;
                      }
                      ResultadosService.getComentarios($scope.filtros.buscador,cat.id,vm.peticion.centro.idioma_code,true,$scope.filtros.remove_tags,$scope.filtros.page,function(result){
                        // Si no se obtienen resultados poco hay que hacer.
                        if (!angular.isDefined(result.resultados) || result.resultados.length == 0) {
                          // Como suma por fuera, lo reducimos para que no crezca infinito
                          if ($scope.filtros.page > 0) {
                            $scope.filtros.page--;
                          }
                        } else {
                          // Si viene una página $scope.comentarios está vacío, se asigna el resultado 
                          if (angular.isDefined(page) || !angular.isDefined($scope.comentarios)  || $scope.comentarios.length <= 0) {
                            $scope.comentarios = result.resultados;
                          } else {//Si no, se concatena/mergea para seguir el flujo de la paginación.
                            $scope.comentarios = $scope.comentarios.concat(result.resultados);
                          }
                        }
                        
                      });
                    }

                    $scope.init();

                    //$scope.item = item;
                    //$scope.muestra = muestra;
                    //$scope.animal = vm.animal;
                    ////console.log(vm.animal);
                    ////console.log( $scope.item.extra);
                    ////console.log( muestra);
                    $scope.okForm = function(){
                      vm.loadComments = true;
                      var poner = [];
                      for(var cont=0;cont<$scope.comentarios.length;cont++){
                        if($scope.comentarios[cont].poner){
                          if($scope.comentarios[cont].text.indexOf("<p>") != -1){
                            poner.push($scope.comentarios[cont].text);
                          }else{
                            poner.push("<p>"+$scope.comentarios[cont].text+"</p>");

                          }

                        }
                      }
                      $timeout(function(){
                          $scope.peticion.comentarios_json[cat.id].comentario += poner.join("");
                      })
                      vm.loadComments = false;
                      vm.popupComentarios.close();
                    }
                    $scope.koForm = function(){
                        vm.popupComentarios.close();
                    }
                  }
            });
        }

        
        vm.getAcciones = function(){
          ResultadosService.getAccionesByPet(vm.id,function(data){
            vm.generalLab.acciones = data.acciones;
          });
        }
        vm.popupAcciones = "";
        vm.btnAcciones = function(){
          
           vm.popupAcciones = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              //windowClass: 'modal-danger',
              //backdrop  : 'static',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=acciones.twig',
              size: 'lg',
              controller: function($scope) {
                
                $scope.generalLab = vm.generalLab;
                $scope.peticion_id = vm.id;
                $scope.resultados = vm.resultados;

                //$scope.item = item;
                //$scope.muestra = muestra;
                //$scope.animal = vm.animal;
                ////console.log(vm.animal);
                ////console.log( $scope.item.extra);
                ////console.log( muestra);
                $scope.okForm = function(){
                   vm.popupAcciones.close();
                }
                $scope.koForm = function(){
                    vm.popupAcciones.close();
                }
              }
            });
        }

        vm.popupRepetirAn = "";
        vm.repetirAnalitica = function(item){
           vm.popupRepetirAn = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              //windowClass: 'modal-danger',
              //backdrop  : 'static',
              templateUrl: 'repetiranalitica.html',
              size: 'lg',
              controller: function($scope) {
                $scope.item = item;
                console.log("iterem",item);
                $scope.okForm = function(){
                  ResultadosService.repetirAnalitica(item.analitica.id,item.resultado.id,$scope.comentario,function(data){
                      item.resultado.resultado = "";
                      item.resultado.extra = "";
                      item.signo = "";
                      vm.popupRepetirAn.close();
                      vm.getAcciones();
                  });
                }
                $scope.koForm = function(){
                    vm.popupRepetirAn.close();
                }
              }
            });
        }
       
        //vm.blockModal = "";
        /*vm.comprobarBlock = function(visitaCode){
          if(visitaCode.code!=vm.codeVisita){
            switch(visitaCode.code){
              case -2:
                //BLOQUEAMOS PETI
                vm.blockModal = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    //windowClass: 'modal-danger',
                    backdrop  : 'static',
                    templateUrl: 'petiblock.html',
                    size: 'xs',
                    controller: function($scope) {
                      $scope.user = visitaCode.user;
                      $scope.okForm = function(){
                          vm.blockModal.close();
                      }
                      $scope.koForm = function(){
                          vm.blockModal.close();
                      }
                      $scope.controltomar = function(){
                        //vm.limpiarBlock();
                        //vm.visitaResultado(vm.id,true,function(){
                          //vm.limpiarBlock();
                          vm.blockModal.close();
                          vm.init(vm.id,vm.analitica_id,true);
                        //});
                      }
                    }
              });
              break;
              case 1:
                if(vm.blockModal!=""){
                  vm.blockModal.close();
                  vm.init(vm.id,vm.analitica_id,true);
                }
              break;
            }
          }
          vm.codeVisita = visitaCode.code;
        }*/

        vm.analitica_id = "";
        vm.hemogramas = [];
      	vm.init = function(id,analitica_id){
      		vm.id = id;
          

          /*if(typeof(force)=='undefined'){
            vm.timeVisita = setTimeout(function(){
              vm.visitaResultado(id,false);
            },10000);
          }*/
          vm.analitica_id = analitica_id;
          ////console.log(vm.analitica_id);
          vm.loading = true;
  		    ResultadosService.getAnaliticasByIdPeticion(vm.id,analitica_id,function(data){
            vm.hemogramas = data.hemogramas;
              vm.loading = false;
              vm.resultados = data.resultados;
              vm.peticion = data.peticion;
              vm.animal = data.animal;
              vm.lang_trans = vm.peticion.centro.idioma_id;
              vm.getTablaNotas();

              vm.generalLab.currentPeticion = { id: vm.peticion.id, lims_id:vm.peticion.lims_id };
              /*if(typeof(force)=='undefined'){
                vm.comprobarBlock(data.codeVisita);
              }*/

              for(var cont=0;cont<vm.resultados.length;cont++){
                vm.generalLab.setInterpretaciones(vm.resultados[cont]);
                for(var cont2=0;cont2<vm.resultados[cont].analiticas.length;cont2++){
                  var tecnica = vm.resultados[cont].analiticas[cont2].analitica.tecnica_id;
                  if(tecnica){
                    ////console.log(tecnica);
                    if(!angular.isArray(tecnica)){
                      tecnica = (""+vm.resultados[cont].analiticas[cont2].analitica.tecnica_id).split(",");
                    }
                    if(!vm.resultados[cont].analiticas[cont2].resultado)
                      vm.resultados[cont].analiticas[cont2].resultado = { tecnica_id : tecnica[0] };
                    }
                    ////console.log(vm.resultados[cont].analiticas[cont2]);
                }
              }
              vm.renovarCookie(data.cookie);
              vm.socket.emit('create', {room:vm.id,username:vm.userName,cookie:vm.cookie});
          });
      	}
        vm.userName = ""; 
        vm.setUser = function(username){
          vm.userName = username;
        }

        vm.trazModal = "";
        vm.trazabilidadMuestra = function(){
          PreanaliticaService.getTrazabilidadMuestra(vm.resultados[0].id,function(data){
            vm.trazModal = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              //windowClass: 'modal-danger',
              //backdrop  : 'static',
              templateUrl: 'trazamuestra.html',
              size: 'lg',
              controller: function($scope) {
                $scope.data = data;
                $scope.okForm = function(){
                  vm.trazModal.close();
                }
                $scope.koForm = function(){
                  vm.trazModal.close();
                }
              }
            });
          })
          
        }

        vm.popupModal = "";
        vm.popupInfo = function(item,muestra){
          //console.log("muestra",muestra);
          vm.popupModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  //backdrop  : 'static',
                  templateUrl: 'popupinfo.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.item = item;
                    $scope.muestra = muestra;
                    $scope.animal = vm.animal;
                    $scope.extra = "";
                    ////console.log($scope.muestra.a);
                    var res = false;
                    if(!$scope.item.extra){
                      for(var cont=0;cont<$scope.muestra.analiticas.length && !res;cont++){
                        if($scope.muestra.analiticas[cont].extra){
                          //console.log($scope.muestra.analiticas[cont].extra);
                          for(var cont2=0;cont2<$scope.muestra.analiticas[cont].extra.length && !res;cont2++){
                            if($scope.muestra.analiticas[cont].extra[cont2].analitica.id==$scope.item.analitica.id){
                              $scope.extra = [$scope.muestra.analiticas[cont].extra[cont2]];
                              res = true;
                            }

                          }
                        }
                      }

                      if(!$scope.extra && angular.isDefined($scope.muestra.extra)){
                          for(var cont2=0;cont2<$scope.muestra.extra.analiticas.length && !res;cont2++){
                            var parseado = JSON.parse($scope.muestra.extra.analiticas[cont2]);
                            //console.log("parse",parseado);
                            for(var cont3=0;cont3 < parseado.length;cont3++){
                              if(parseado[cont3].analitica.formulario==$scope.item.analitica.formulario){
                                //console.log("EXTRA OK");
                                 $scope.extra = [parseado[cont3]];
                                res = true;
                              }
                            }
                        }
                      }
                    }else{
                      $scope.extra = $scope.item.extra;
                    }
                    //console.log($scope.extra);
                    ////console.log(vm.animal);
                    ////console.log( $scope.item.extra);
                    ////console.log( muestra);
                    $scope.okForm = function(){
                       vm.popupModal.close();
                    }
                    $scope.koForm = function(){
                        vm.popupModal.close();
                    }
                  }
            });
        }

        vm.validadorModal = "";
        vm.comentarioModal = "";
        vm.mostrarLogin = function(ok,ko){
            vm.validadorModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  backdrop  : 'static',
                  templateUrl: 'loginvalidador.html',
                  size: 'lg',
                  controller: function($scope) {
                       $scope.login = {};
                    $scope.okForm = function(){
                        ResultadosService.validador($scope.login,function(data){
                            if(data.code==1){
                                //resultado.validado = (resultado.validado == 0 ? 1 : 0);
                                vm.renovarCookie(data);
                                if(typeof(ok)!='undefined'){
                                  ok();
                                }
                                vm.validadorModal.close();
                            }
                        })

                    }
                    $scope.koForm = function(){
                        //ko();
                        vm.loading = false;
                        vm.validadorModal.close();
                    }
                  }
            });
        }

        vm.notasModal = "";

        vm.getTablaNotas = function(){
            ResultadosService.getTablanotas(vm.lang_trans,function(data){
              vm.tablanotasvalores = data.result;
            });

        }

        vm.enviarTodosResultados = function(categoria,peticion){
          angular.forEach(vm.resultadosMaquina[categoria.id], function(resmaq, key){
            vm.enviarResultados(resmaq,peticion);
          });
          $("html, body").animate({ scrollTop: $('.boxresultados').offset().top }, 600);

        }

        vm.tablaNotas = function(){
          vm.notasModal = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-top',
            ariaDescribedBy: 'modal-body-top',
            //windowClass: 'modal-danger',
            //backdrop  : 'static',
            templateUrl: 'tablanotas.html',
            size: 'lg',
            controller: function($scope) {
              $scope.tablanotasvalores = vm.tablanotasvalores;
              $scope.nuevoValor = function(){
                $scope.tablanotasvalores.push({"palabras":"","reemplazo":""});
              }
                $scope.okForm = function(){
                  vm.tablanotasvalores = $scope.tablanotasvalores;
                  ResultadosService.saveTablanotas(vm.lang_trans,$scope.tablanotasvalores,function(data){
              
                  });
                  vm.notasModal.close();
                }
                $scope.koForm = function(){
                  vm.notasModal.close();
                }
            }
          });
        }

        vm.histocioModal = "";
        vm.verHistorico = function(item){
          ////console.log("historico");
          vm.histocioModal = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-top',
            ariaDescribedBy: 'modal-body-top',
            //windowClass: 'modal-danger',
            //backdrop  : 'static',
            templateUrl: 'historico.html',
            size: 'lg',
            controller: function($scope) {
                $scope.item = item;
                $scope.okForm = function(){
                  vm.histocioModal.close();
                }
                $scope.koForm = function(){
                  vm.histocioModal.close();
                }
            }
          });
        }

        vm.validarTodos = function(categoria,peticion){
            var resultado = false;
            console.log("categoria",categoria);
            console.log("peticion",peticion);
            for(var cont=0;cont<peticion.analiticas.length;cont++){
                if(categoria.id==peticion.analiticas[cont].analitica.categoriaanalitica_id){
                    ////console.log(peticion.analiticas[cont]);
                    if(!peticion.analiticas[cont].resultado){
                      if(peticion.analiticas[cont].resultado.resultado!='' && typeof(peticion.analiticas[cont].resultado.resultado) != 'undefined'){
                        peticion.analiticas[cont].resultado = {validado:1};
                      }
                    }else{
                      if(peticion.analiticas[cont].resultado.validado==1){
                        //peticion.analiticas[cont].resultado.validado = 0;
                      }else{
                        if(peticion.analiticas[cont].resultado.resultado!='' && typeof(peticion.analiticas[cont].resultado.resultado) != 'undefined'){
                          peticion.analiticas[cont].resultado.validado = 1;
                        }

                      }
                    }
                }
                //vm.enviarSocket(peticion.analiticas[cont]);
            }
            console.log("peticion",peticion);
        }

        vm.changeMostrar = function(peticion){
           vm.loadingFull = true;
           ////console.log(peticion.id);
            ResultadosService.cambiarMostrar(peticion.id,peticion.mostrar_web,function(data){
                vm.guardarResultados(peticion,'',false,function(){
                  //vm.resultados.mostrar = data.resultados;
                  //vm.categorias = data.categorias;
                  vm.loadingFull = false;
                  vm.getAcciones();
                });
            })
           
        }

          vm.loadingFull = false;
        vm.guardarResultados = function(peticion,analitica_id,cerrar,callback){
          ////console.log(peticion);
          var resSimplificados = [];
          var validadas = [];
          vm.loadingFull = true;
          for(var cont = 0;cont<peticion.analiticas.length;cont++){
            resSimplificados.push({peticion_id:peticion.analiticas[cont].peticion_id,analitica_id:peticion.analiticas[cont].analitica.id,resultado:peticion.analiticas[cont].resultado});
            if(peticion.analiticas[cont].resultado.validado==1){
              validadas.push(peticion.analiticas[cont].resultado);
            }
          }
          console.log("resSim",resSimplificados);
          ResultadosService.guardarResultados(analitica_id,peticion.id,resSimplificados,peticion.comentarios_json,function(data){
              if(typeof(callback)!='undefined'){
                callback(data);
              }
              vm.socket.emit('peticion:guardar', { id:peticion.id, datapet:data, infopet:{}, validar:false, validadas:validadas });
              if(cerrar){
                //vm.limpiarBlock();
                  vm.cerrarPopup({ id:peticion.id, datapet:{}, infopet:{}, validar:'',validadas:validadas });

                //$scope.$emit("cerrarPopup");
              }else{
                $timeout(function(){
                  //vm.resultados = data.resultados;
                  //vm.categorias = data.categorias;
                  vm.loadingFull = false;
                })
              }
              
              
          })
        }
        vm.guardarResultadoItem = function(itemSimple,comprobar,callback){
          vm.loading = true;
          ResultadosService.cambiarResultado(itemSimple.peticion_id,comprobar,itemSimple,function(data){
                
                if(data.code==1){
                    vm.renovarCookie(data.cookie);
                    itemSimple.resultado.id = data.id;
                    
                }
                callback(data);
                vm.loading = false;
            })
        }
        vm.guardarOnChange = function(item){
            item.loading = true;
            var itemSimple = { peticion_id:item.peticion.id,analitica_id:item.analitica.id,resultado:item.resultado };
            vm.guardarResultadoItem(itemSimple,false,function(data){
              item.loading = false;
            })
        }


        vm.revisarValidados = function(peticion){
          var res = true;
          for(var cont=0;cont<peticion.analiticas.length && res;cont++){
            if((!peticion.analiticas[cont].resultado.validado && (!peticion.analiticas[cont].analitica.grupoanaliticas_id)) || (!isNaN(peticion.analiticas[cont].resultado.resultado) && peticion.analiticas[cont].resultado.resultado<0)){
              console.log("analitica a revisar",peticion.analiticas[cont]);
              ////console.log(peticion.analiticas[cont].analitica.grupoanaliticas_id);
              res = false;
            }

          }
          return res;
        }
        vm.enviarSocket = function(data){
          vm.socket.emit('change:results', data);
           ////console.log("resultado",data);
        }
        vm.resetEvents = function(){
          vm.socket.removeListener("user:listado");
          vm.socket.removeListener("peticion:guardar");
          vm.socket.removeListener("change:results");

        }

        vm.enviarChatModal = false;
        vm.enviarchat = function(){
          vm.enviarChatModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  //backdrop  : 'static',
                  templateUrl: 'enviarchat.html',
                  size: 'full',
                  controller: function($scope) {
                    // Función quie inicializa los comentarios para llamarla con ng-change
                    
                    $scope.okForm = function(){
                      vm.enviarChatModal.close();
                    }
                    $scope.koForm = function(){
                        vm.enviarChatModal.close();
                    }
                  }
            });
        }
        
        vm.cerrarPopup = function(data){
          if(typeof(data)!='undefined'){
            $scope.$emit("cerrarPopup",data);
          }else{
            $scope.$emit("cerrarPopup");
          }
          vm.socket.emit('user:left', data.id);
          vm.generalLab.currentPeticion = false;

          //vm.resetEvents();
          //vm.socket.removeAllListeners();
          ////console.log("REMOVEALLLISTENERS");
        }
        vm.cerrarInforme = function(){
          vm.cerrarPopup({id:vm.id,datapet:{},datainfo:{}});
          //vm.limpiarBlock();
        }
        vm.faltavalidar = "";
        vm.validarInforme = function(peticion,validar){
          
          if(vm.cookie){
            
            if(!validar){
              vm.comentarioModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                backdrop  : 'static',
                templateUrl: 'comentario.html',
                size: 'lg',
                controller: function($scope) {
                    $scope.item = {};
                    $scope.okForm = function(){
                     vm.loadingFull = true;
                      peticion.comentario = $scope.item.resultado.comentario;
                      ResultadosService.validarInforme(peticion.id,peticion,validar,function(data){
                          //vm.limpiarBlock();
                          //vm.cerrarPopup({ id:peticion.id, datapet:data, infopet:{}, validar:validar });
                          //$scope.$emit("cerrarPopup",{ id:peticion.id, datapet:data, infopet:{}, validar:validar });
                          vm.socket.emit('peticion:guardar', { id:peticion.id, datapet:data, infopet:{}, validar:validar });
                          vm.loadingFull = false;
                          if(data.code==1){
                            peticion.fecha_validacion = data.fecha_validacion;
                          }
                          vm.getAcciones();

                          vm.comentarioModal.close();
                         
                      })
                    }
                    $scope.koForm = function(){
                        vm.loading = false;
                        vm.comentarioModal.close();
                    }
                }
              });
            }else{
              if(validar){
                if(!vm.revisarValidados(peticion)){
                  vm.faltavalidar = $uibModal.open({
                      animation: true,
                      ariaLabelledBy: 'modal-title-top',
                      ariaDescribedBy: 'modal-body-top',
                      //windowClass: 'modal-danger',
                      //backdrop  : 'static',
                      templateUrl: 'validartodo.html',
                      size: 'lg',
                      controller: function($scope) {
                          $scope.okForm = function(){
                               vm.faltavalidar.close();
                          }
                      }
                    });
                    return false;
                }
                //vm.guardarResultados(peticion,'',function(data){
                  vm.loadingFull = true;
                  ResultadosService.validarInforme(peticion.id,{},validar,function(datapet){
                      vm.guardarResultados(peticion,'',false,function(data){
                        /*var res = false;
                        for(var cont=0;cont<data.resultados.length && !res;cont++){
                          if(data.resultados[cont].id==peticion.id){
                            res = data.resultados[cont];
                          }
                        }*/
                        //vm.limpiarBlock();
                        ////console.log("EMIT Y CERRARPOPUP");
                        //IGNORAMOS EL CERRAR POPUP SIEMPRE QUE VALIDAMOS
                        vm.socket.emit('peticion:guardar', { id:peticion.id, datapet:datapet, infopet:data, validar:validar });
                        vm.cerrarPopup({ id:peticion.id, datapet:datapet, infopet:data, validar:validar });
                        //$scope.$emit("cerrarPopup",{ id:peticion.id, datapet:datapet, infopet:data, validar:validar });
                      });
                      vm.loadingFull = false;
                      ////console.log(datapet);
                      if(datapet.code==1){
                          peticion.fecha_validacion = datapet.fecha_validacion;
                      }
                      vm.getAcciones();

                  })
                //});
              }
              
            }
          }else{
            vm.mostrarLogin(function(){
              /*vm.loadingFull = true;
              ResultadosService.validarInforme(peticion.id,{},validar,function(data){
                  vm.loadingFull = false;
                  if(data.code==1){
                    peticion.fecha_validacion = data.fecha_validacion;
                  }
              })*/
            },function(){
              
            });

          }
        }
        vm.validar = function(item){
            ////console.log(item);
            var itemSimple = { peticion_id:item.peticion_id,analitica_id:item.analitica.id,resultado:item.resultado };
            if(vm.cookie){
                if(item.resultado.validado==0){
                  //console.log(item.resultado.fecha_validacion);
                    if(!item.resultado.fecha_validacion){
                      vm.enviarSocket(item);
                      return;
                    }
                    vm.comentarioModal = $uibModal.open({
                      animation: true,
                      ariaLabelledBy: 'modal-title-top',
                      ariaDescribedBy: 'modal-body-top',
                      //windowClass: 'modal-danger',
                      backdrop  : 'static',
                      templateUrl: 'comentario.html',
                      size: 'lg',
                      controller: function($scope) {
                          $scope.item = item;
                          $scope.okForm = function(){
                            vm.guardarResultadoItem(itemSimple,true,function(data){
                              vm.comentarioModal.close();
                              if(data.code==1){
                                item.resultado.comentario = "";
                                if(data.comentarioMod){
                                  item.historico.unshift(data.comentarioMod);
                                }
                              }
                              if(data.code==-1){
                                  vm.mostrarLogin(function(){
                                    vm.validar(item);
                                  },function(){
                                    item.resultado.validado = (item.resultado.validado == 0 ? 1 : 0);
                                  });
                              }
                              vm.enviarSocket(item);

                            })
                          }
                          $scope.koForm = function(){
                              item.resultado.validado = (item.resultado.validado == 0 ? 1 : 0);
                              vm.enviarSocket(item);
                              vm.loading = false;
                              vm.comentarioModal.close();
                          }
                      }
                    });
                }else{
                  vm.guardarResultadoItem(itemSimple,true,function(data){
                    if(data.code==-1){
                        vm.mostrarLogin(function(){
                                    vm.validar(item);
                                  },function(){
                          item.resultado.validado = (item.resultado.validado == 0 ? 1 : 0);
                        });
                    }
                    if(data.code==1){
                        vm.renovarCookie(data.cookie);
                    }
                    vm.enviarSocket(item);
                  });
                }
            }else{
                vm.mostrarLogin(function(){
                  vm.validar(item);
                  vm.enviarSocket(item);
                },function(){
                  item.resultado.validado = (item.resultado.validado == 0 ? 1 : 0);
                  vm.enviarSocket(item);
                });
            }
        }
       
        vm.popupCambiarlab = "";
        vm.cambiarLab = function(item){
          vm.popupCambiarlab = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  //backdrop  : 'static',
                  templateUrl: 'cambiarlab.html',
                  size: 'xs',
                  controller: function($scope) {
                    $scope.generalLab = GenerallabService;
                    $scope.loading = false;
                    $scope.item = item;
                   // $scope.lab_id = "";

                    if(typeof(item.lab_res)!='undefined'){
                      //$scope.lab_id = item.lab_res.id;
                    }
                    //console.log("labres",item.lab_res);
                    $scope.okForm = function(){
                      $scope.loading = true;
                      //console.log("lab_id",$scope.item)
                      ResultadosService.cambiarLab(item,$scope.item.lab_res.id,function(data){
                        item.lab_res = data.lab_res;
                        vm.popupCambiarlab.close();
                      });
                     
                    }
                    $scope.koForm = function(){
                        vm.popupCambiarlab.close();
                    }
                  }
            });
        }

        vm.popupMarcarfav = "";
        vm.muestraInteresante = function(item){
            vm.popupMarcarfav = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  //backdrop  : 'static',
                  templateUrl: 'marcarfav.html',
                  size: 'xl',
                  controller: function($scope) {
                    $scope.generalLab = GenerallabService;
                    $scope.loading = false;
                    $scope.peticion = angular.copy(vm.peticion);
                    //console.log("peticion",vm.peticion);
                    $scope.item = item;
                    if(typeof(item.favs)!='undefined'){
                      $scope.favs = item.favs;
                    }else{
                      $scope.favs = [];
                    }
                    console.log("item",item);
                   // $scope.lab_id = "";

                    if(typeof(item.lab_res)!='undefined'){
                      //$scope.lab_id = item.lab_res.id;
                    }

                    $scope.nuevaMuestra = function(tV){
                      console.log("tV",tV);
                      $scope.favs.push({estadomuestra_id:tV.estadomuestra_id,tipomuestra_id:tV.tipomuestra_id,texto:""});
                    }
                    //console.log("labres",item.lab_res);
                    $scope.okForm = function(){
                      $scope.loading = true;
                      ////console.log("lab_id",$scope.item)
                      //vm.popupMarcarfav.close();
                      ResultadosService.marcarFav(item,$scope.favs,function(data){
                        //item.lab_res = data.lab_res;
                        $timeout(function(){
                          $scope.item.favs = data.favs;
                        })
                        vm.popupMarcarfav.close();
                      });
                     
                    }
                    $scope.koForm = function(){
                        vm.popupMarcarfav.close();
                    }
                  }
            });
        }

        vm.enviarResultados = function(resmaq,peticion){
          var res = false;
          if(resmaq.table.analitica_id!=''){
            for(var cont=0;cont<peticion.analiticas.length && !res;cont++){
              if(peticion.analiticas[cont].analitica_id==resmaq.table.analitica_id){
                res=true;
                if(!peticion.analiticas[cont].resultado.validado){
                  //console.log("pongo resultado");
                  peticion.analiticas[cont].resultado.resultado = resmaq.raw.resultado;
                }
              }
            }
            //item.resultado
          }

        }

        vm.getResMaquinaAnalitica = function(peticion_id,analitica,categoria,lims_id){
          //return false;
          ResultadosService.getResMaquinaAnalitica(peticion_id,analitica.id,categoria.id,lims_id,function(data){
            if(angular.isDefined(data.resultados)){
              vm.resultadosMaquina = data.resultados;
            }
            /*if(categoria){
              categoria.maquinas = data.resultados;
            }
            if(analitica){
              analitica.maquinas = data.resultados;
            }*/
            ////console.log(data);
          });
        }

        vm.existeBasico = function(categoria,peticion){
            var resultado = false;
            for(var cont=0;cont<peticion.analiticas.length && !resultado;cont++){
                //////console.log(peticion.analiticas[cont].analitica.formulario_resultado);
                if(!peticion.analiticas[cont].analitica.formulario_resultado && categoria.id==peticion.analiticas[cont].analitica.categoriaanalitica_id){
                    resultado = true;
                }
            }
            return resultado;
        }
        vm.popupInfoMod = "";
        vm.valoresNormalidadInfo = function(item){
          vm.popupInfoMod = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                //backdrop  : 'static',
                templateUrl: '/backend/resultadopeticion/templateresultados?name=infovaloresnorm.twig',
                size: 'lg',
                controller: function($scope) {
                  $scope.item = item;
                 

                  $scope.okForm = function(){
                    vm.popupInfoMod.close();
                  }
                  $scope.koForm = function(){
                    //CERRAMOS.
                    vm.popupInfoMod.close();
                  }
                }
          });
          //console.log(item);
        }

        
        vm.categoriaEstado = function(categoria,peticion){
            var totalCategoria = 0;
            var totalResultados = 0;
            for(var cont=0;cont<peticion.analiticas.length;cont++){
                if(categoria.id==peticion.analiticas[cont].analitica.categoriaanalitica_id){
                    totalCategoria++;
                    if(peticion.analiticas[cont].resultado.validado==1){
                        totalResultados++;
                    }
                }
            }

            var clase = "red"
            if(totalResultados>0){
                if(totalResultados==totalCategoria){
                    clase = "green";
                }else{
                    clase = "orange";
                }

            }
            return clase;
        }
        vm.popupCambioanal = "";
        vm.popupChangeAnalitica = function(item){
            ResultadosService.getAnaliticasSimilares(item,function(result){
              vm.popupCambioanal = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    //windowClass: 'modal-danger',
                    //backdrop  : 'static',
                    templateUrl: '/backend/resultadopeticion/templateresultados?name=cambioanalitica.twig',
                    size: 'lg',
                    controller: function($scope) {
                      $scope.item = item;
                      $scope.analiticas = result.analiticas;
                      $scope.prueba_final = item.analitica_id;

                      $scope.cambiarPrueba = function(analitica){
                        $scope.prueba_final = analitica.id;
                        //console.log($scope.prueba_final);

                      }
                      
                      $scope.okForm = function(){
                         ResultadosService.cambiarAnalitica($scope,function(result){

                            //GUARDAMOS.
                            vm.popupCambioanal.close();
                            vm.init($scope.item.peticion_id);
                         })
                      }
                      $scope.koForm = function(){
                        //CERRAMOS.
                          vm.popupCambioanal.close();
                      }
                    }
              });
            });
            //console.log(item);
        }
        
        vm.cartaModal = false
        vm.addPublicacion = function(peticion,categoria,item){
             vm.cartaModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'addpublicacion.html',
                  size: 'md',
                  backdrop:'static',
                  controller: function($scope) {
                    $scope.newCard = {
                      especie_id:vm.animal.especie.id,
                      lims_id:vm.peticion.lims_id,
                      peticion_id:vm.peticion.id
                    };
                    if(angular.isDefined(item)){
                      $scope.newCard = item;
                    }
                    $scope.item = item;
                    $scope.okForm = function(){
                        console.log("newCard",$scope.newCard);
                        FotopublicacionService.nuevaPublicacion($scope.newCard,function(data){
                          if(!angular.isDefined(peticion.comentarios_json[categoria.id].publicaciones)){
                             peticion.comentarios_json[categoria.id].publicaciones = [];
                          }
                          if(!angular.isDefined(item)){
                            peticion.comentarios_json[categoria.id].publicaciones.push(data.publicacion);
                            console.log("comentariosjson",peticion.comentarios_json);
                          }
                          vm.cartaModal.close();
                        });
                    }

                    $scope.koForm = function(){
                        vm.cartaModal.close();
                    }
                   
                  }
              });
        }

        

        vm.timeBetweenDates = function(toDate) {
          var dateEntered = toDate;
          var now = new Date();
          var difference = dateEntered.getTime() - now.getTime();
          if (difference <= 0) {
            // Timer done
            clearInterval(vm.timer);
            $timeout(function(){
                vm.cookie = false;
            });
          } else {
            
            var seconds = Math.floor(difference / 1000);
            var minutes = Math.floor(seconds / 60);
            var hours = Math.floor(minutes / 60);
            var days = Math.floor(hours / 24);

            hours %= 24;
            minutes %= 60;
            seconds %= 60;
            $timeout(function(){
              if(hours){
                vm.cookie.hours = hours;
              }
              if(minutes){
                vm.cookie.minutes = minutes;
              }
              if(seconds){
                vm.cookie.seconds = seconds;
              }
            })
            
          }

      }
    }
})();